import React from "react";

const AttentiveLogo = ({ width = 34, height = 30 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 34 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.9223 29.9244H21.8446L21.8422 29.9197L18.8034 23.4243L13.9623 13.0687L6.07771 29.9244H0L1.70833 26.2731L10.9235 6.57097L13.96 0.0755615H13.9623L17.0012 6.57097L21.8422 16.9265L24.8811 23.4243L26.214 26.2731L27.9223 29.9244Z"
        fill="#0F291B"
      />
      <path
        d="M34.0001 29.9245H27.9223L26.214 26.2731L24.8811 23.4243L21.8423 16.9266L24.8811 10.4288L27.92 16.9266L29.4054 20.0992L34.0001 29.9245Z"
        fill="#4CBB7F"
      />
      <path
        d="M21.8424 29.9197V29.9244H15.7646L18.8035 23.4243L21.8424 29.9197Z"
        fill="#4CBB7F"
      />
    </svg>
  );
};

export default AttentiveLogo;
